import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCustomerAuth } from '../../context/CustomerAuthContext';
import { API_ENDPOINTS } from '../../config/api';

const T = {
  ink: '#1f2937',
  inkLight: '#6b7280',
  border: 'rgba(17,24,39,0.08)',
  gradient: 'linear-gradient(45deg, #ec4899, #8b5cf6, #06b6d4)',
  green: '#15803d',
  red: '#b91c1c',
};

const card = { background: '#fff', border: `1px solid ${T.border}`, borderRadius: 14, padding: '16px 18px', marginBottom: 16 };
const input = { padding: '10px 12px', border: `1px solid ${T.border}`, borderRadius: 10, fontSize: 14, textTransform: 'uppercase' };
const primaryBtn = { background: T.gradient, color: '#fff', border: 'none', borderRadius: 10, padding: '10px 18px', fontSize: 13, cursor: 'pointer', fontWeight: 600 };

const AccessTab = ({ onSecretShopUnlocked }) => {
  const navigate = useNavigate();
  const { getAuthHeaders } = useCustomerAuth();
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null); // { ok: boolean, message: string, type?: string, link?: string }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setSubmitting(true);
    setResult(null);
    try {
      const res = await fetch(API_ENDPOINTS.customerProfile.redeemCode, {
        method: 'POST',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code.trim() }),
      });
      const data = await res.json();
      if (data?.success && data.data?.type === 'event') {
        setResult({ ok: true, message: `Unlocked "${data.data.event.name}"`, type: 'event', link: data.data.link });
      } else if (data?.success && data.data?.type === 'secret_shop') {
        setResult({ ok: true, message: 'Unlocked the Exclusive shop', type: 'secret_shop' });
      } else {
        setResult({ ok: false, message: data?.error || 'That code did not work.' });
      }
      setCode('');
    } catch (err) {
      setResult({ ok: false, message: err.message || 'That code did not work.' });
    } finally {
      setSubmitting(false);
    }
  };

  const handleViewIt = () => {
    if (result?.type === 'secret_shop') {
      onSecretShopUnlocked?.();
    } else if (result?.link) {
      navigate(result.link);
    }
  };

  return (
    <div>
      <div style={card}>
        <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>Have a code?</div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <input
            style={{ ...input, maxWidth: 220 }}
            placeholder="Enter code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <button type="submit" style={primaryBtn} disabled={submitting}>{submitting ? 'Checking…' : 'Unlock'}</button>
        </form>
        {result && (
          <div style={{ marginTop: 12 }}>
            <p style={{ fontSize: 13, color: result.ok ? T.green : T.red, margin: 0, fontWeight: 600 }}>
              {result.ok ? `🎉 ${result.message}` : result.message}
            </p>
            {result.ok && (
              <button
                type="button"
                onClick={handleViewIt}
                style={{ ...primaryBtn, marginTop: 10, background: '#fff', color: T.ink, border: `1px solid ${T.border}` }}
              >
                View it now →
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AccessTab;
